import { useState } from "react";
import ScheduleDialog from "./shedule_order";



function DisplayPromoContent() {
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => setDialogOpen(true);
  const handleCloseDialog = () => setDialogOpen(false);

  return (
    <section className="w-full px-4 py-16 md:py-24 relative">
      {/* Background with gradient and subtle pattern */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0f1218] to-[#1f2937]">
        <div
          className="absolute inset-0 opacity-[0.03]"
          style={{
            backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
          }}
        />
      </div>

      {/* Content */}
      <div className="relative max-w-6xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Why Choose{" "}
            <span className="bg-gradient-to-r from-orange-500 to-orange-300 bg-clip-text text-transparent">
              MuftyCare
            </span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            Experience the perfect blend of modern technology and traditional care
            in every garment we handle.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Feature Card 1 */}
          <div className="p-6 rounded-2xl bg-gradient-to-br from-black/40 to-black/20 backdrop-blur-sm border border-white/[0.08] hover:border-orange-500/30 transition-colors">
            <div className="w-12 h-12 mb-6 rounded-xl bg-orange-500/10 flex items-center justify-center">
              <svg
                className="w-6 h-6 text-orange-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-white mb-3">
              Premium Quality
            </h3>
            <p className="text-gray-400 leading-relaxed">
              Expert handling of all fabric types with professional-grade cleaning
              processes and quality inspection at every step.
            </p>
          </div>

          {/* Feature Card 2 */}
          <div className="p-6 rounded-2xl bg-gradient-to-br from-black/40 to-black/20 backdrop-blur-sm border border-white/[0.08] hover:border-orange-500/30 transition-colors">
            <div className="w-12 h-12 mb-6 rounded-xl bg-orange-500/10 flex items-center justify-center">
              <svg
                className="w-6 h-6 text-orange-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-white mb-3">
              Real-Time Updates
            </h3>
            <p className="text-gray-400 leading-relaxed">
              Track your order status instantly with our advanced tracking system
              and receive timely WhatsApp notifications.
            </p>
          </div>

          {/* Feature Card 3 */}
          <div className="p-6 rounded-2xl bg-gradient-to-br from-black/40 to-black/20 backdrop-blur-sm border border-white/[0.08] hover:border-orange-500/30 transition-colors">
            <div className="w-12 h-12 mb-6 rounded-xl bg-orange-500/10 flex items-center justify-center">
              <svg
                className="w-6 h-6 text-orange-500"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z"
                />
              </svg>
            </div>
            <h3 className="text-xl font-semibold text-white mb-3">
              Affordable Pricing
            </h3>
            <p className="text-gray-400 leading-relaxed">
              Competitive rates without compromising on quality. Transparent
              pricing with no hidden charges.
            </p>
          </div>
        </div>

        {/* Stats Section with slight modification */}
        <div className="mt-16 p-8 rounded-2xl bg-gradient-to-br from-black/30 to-black/10 backdrop-blur-sm border border-white/[0.08]">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <div className="text-3xl font-bold text-orange-500 mb-2">100000+</div>
              <div className="text-gray-400">Happy Customers</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-orange-500 mb-2">24/7</div>
              <div className="text-gray-400">Customer Support</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-orange-500 mb-2">99%</div>
              <div className="text-gray-400">Satisfaction Rate</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-bold text-orange-500 mb-2">2hr</div>
              <div className="text-gray-400">Average Turnaround</div>
            </div>
          </div>
        </div>

        {/* CTA Section with enhanced styling */}
        <div className="mt-16 text-center p-8 rounded-2xl bg-gradient-to-br from-orange-500/10 to-orange-500/5 backdrop-blur-sm border border-orange-500/20">
          <h2 className="text-3xl md:text-4xl font-bold bg-gradient-to-r from-orange-500 to-orange-300 bg-clip-text text-transparent mb-6">
            Experience Premium Laundry Care Today
          </h2>
          <p className="text-gray-400 mb-8 max-w-2xl mx-auto">
            Join hundreds of satisfied customers who trust us with their garments.
            Premium quality, affordable prices, and exceptional service.
          </p>
          <button
            className="px-8 py-3 rounded-lg bg-orange-500 text-black font-semibold hover:bg-orange-600 transition-colors"
            onClick={handleOpenDialog}
          >
            Book Now
          </button>
        </div>
      </div>
      {/* ScheduleDialog Popup */}
      <ScheduleDialog open={dialogOpen} handleClose={handleCloseDialog} />
    </section>
  );
}

export default DisplayPromoContent;